import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getCalendarioFinanzasMensual = async () => {
        
    const result = await PrivateInterceptor(`Base/Global/CalendarioFinanzas/mensual`, 'GET');
    return result;
}

export const getCalendarioFinanzasMensualProduccion = async () => {
        
    const result = await PrivateInterceptor(`Base/Global/CalendarioFinanzas/mensualProduccion`, 'GET');
    return result;
}


export const getCalendarioFinanzasSemanasProduccion= async () => {
        
    const result = await PrivateInterceptor(`Base/Global/CalendarioFinanzas/semanasProduccion`, 'GET');
    return result;
}

